const ALPHANUMERIC_NAME_PATTERN = /^[a-zA-Z0-9 ]+$/;

// Matches app-am-risk NewRisk / RenameRisk name rules (letters, numbers, spaces only).
export function isAlphanumericName(name: string): boolean {
	return ALPHANUMERIC_NAME_PATTERN.test(name);
}

export function isBlankName(name: string | undefined | null): boolean {
	return (name ?? '').trim().length === 0;
}

export function isDuplicateName(
	name: string,
	existingNames: (string | null | undefined)[],
	excludeName?: string,
): boolean {
	const normalized = name.trim().toLowerCase();
	if (!normalized) {
		return false;
	}

	const excludeNormalized = excludeName?.trim().toLowerCase();

	return existingNames.some(existingName => {
		const existingNormalized = (existingName ?? '').trim().toLowerCase();
		if (!existingNormalized) {
			return false;
		}
		if (excludeNormalized && existingNormalized === excludeNormalized) {
			return false;
		}
		return existingNormalized === normalized;
	});
}
